<template>
    <div class="wizard-header" :id="`wizard-header${ecommerce ? '-ecommerce' : ''}`">
        <div class="row">
            <div 
                class="col-12" 
                :class="{
                    'col-md-8': !fullWidth && !ecommerce,
                    'col-md-10': ecommerce
                    }">
                <h4 
                    :class="{'c6': ecommerce, 'h4b c7': !ecommerce}"
                >{{title}}</h4>
                <p v-html="description"
                    class="p2n"
                    :class="{
                        'c24 subtitle': ecommerce, 
                        'c14': !ecommerce
                    }"
                ></p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Heading',
    props: {
        title: String,
        description: String,
        fullWidth: Boolean,
        ecommerce: Boolean
    },
}
</script>

<style lang="scss" scoped>
    #wizard-header-ecommerce {
        h4 {
            font-size: 20px;
            font-weight: bold;
        }

        .subtitle {
            line-height: 24px;
        }
    }
</style>